// extracted by mini-css-extract-plugin
module.exports = {"cloud_full":"FJCloudFulledButton_cloud_full__wIUWR","full_icon":"FJCloudFulledButton_full_icon__1yYgh","full_desc":"FJCloudFulledButton_full_desc__1nFBC"};